export * from './GrupoEconomicoServiceAdapter'